import { apiConfig } from '@/config';

import { decryptAesEcbBase64 } from './utils';
import {
    InitiateVTIDepositResponse,
    InitiateVTIDepositParams,
    GetVTIFxRateResponse,
    VTIResponseInterface,
    GetVTIFxRateParams,
} from './types';
import { orbis } from '../api';

const axios = orbis.getApiClient().getAxios();

axios.interceptors.request.use((config) => {
    if (config.url?.startsWith(apiConfig.vtiUrl)) {
        const accessToken = orbis.getApiClient().getAuthData()?.accessToken;
        if (accessToken) {
            config.headers = config.headers || {};
            config.headers.Authorization = `SessionId ${accessToken}`;
        }
    }
    return config;
});

export const vtiMutations = {
    getFxRate: async ({ bank, ...payload }: GetVTIFxRateParams): Promise<GetVTIFxRateResponse> => {
        const response = await axios.post<VTIResponseInterface<GetVTIFxRateResponse>>(
            `${apiConfig.vtiUrl}/fx/lrs?bank=${bank}`,
            payload,
        );
        return response.data.data;
    },
    initiateDeposit: async ({ bank, ...payload }: InitiateVTIDepositParams): Promise<InitiateVTIDepositResponse> => {
        const response = await axios.post<VTIResponseInterface<InitiateVTIDepositResponse>>(
            `${apiConfig.vtiUrl}/deposit?bank=${bank}`,
            payload,
        );
        return {
            ...response.data.data,
            payload: decryptAesEcbBase64(response.data.data.payload, apiConfig.vtiDecryptKey),
        };
    },
};
